import "./BTNtoTop.css";

function BTNtoTop() {
  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="btn-to-top-wrapper">
      <div className="btn-to-top" onClick={handleBackToTop}>
        Voltar ao topo
      </div>
    </div>
  );
}

export default BTNtoTop;
